import { z } from 'zod';

export const CaseDataFieldSchema = z.string().trim();

export type CaseDataField = z.infer<typeof CaseDataFieldSchema>;

export const CaseDataFields = z.object({
  caseDataFields: z.record(CaseDataFieldSchema, z.unknown())
});

export type CaseDataFields = z.infer<typeof CaseDataFields>;
